import { Button, Container, Eyebrow, startCheckout } from './primitives'

const CARDS = [
  {
    tier: 'Vello Launch',
    tag: 'One-time',
    price: '$1,999',
    priceNote: 'flat, no add-ons',
    desc: 'A complete 5-page site, designed, built, and deployed on your domain.',
    cta: 'Start your site',
    plan: 'launch',
    features: [
      'Custom 5-page site, Home, About, How I Work, Case Studies, Contact',
      'Designed, built, and deployed on your domain',
      'Lead capture wired to your email, HubSpot, Pipedrive, or Attio',
      '7-day turnaround, start to finish',
      'Stripe Checkout, no sales call',
      'Intake runs after payment, on the thank-you page',
    ],
    featured: true,
  },
  {
    tier: 'Vello+',
    tag: 'Retainer',
    price: '$299',
    priceNote: 'per month, cancel anytime',
    desc: 'Keep the site sharp. One request at a time, forty-eight hours each.',
    cta: 'Add Vello+',
    plan: 'plus',
    features: [
      'Unlimited edits, one request at a time',
      '48-hour turnaround per request',
      'New pages, case studies, copy updates',
      'Hosting, uptime monitoring, and weekly backups',
      'Connects to your CRM of choice',
      'Cancel anytime, keep everything',
    ],
    featured: false,
  },
] as const

export function Offer() {
  return (
    <section id="pricing" style={{ padding: '120px 0 96px' }}>
      <Container>
        <div style={{ maxWidth: 720, marginBottom: 64 }}>
          <Eyebrow>The offer</Eyebrow>
          <h2
            style={{
              fontSize: 'clamp(32px, 4.2vw, 56px)',
              lineHeight: 1.05,
              letterSpacing: '-0.025em',
              fontWeight: 400,
              margin: '20px 0 20px',
              fontFamily: 'var(--serif)',
            }}
          >
            Launch once. Retain if you want it.
          </h2>
          <p
            style={{
              fontSize: 18,
              lineHeight: 1.55,
              color: 'var(--muted)',
              margin: 0,
            }}
          >
            One flat price to ship. A lightweight retainer if you want ongoing edits.
            Either way, no sales call and the site is yours to keep.
          </p>
        </div>

        <div
          className="price-grid"
          style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}
        >
          {CARDS.map((c) => (
            <div
              key={c.tier}
              style={{
                border: c.featured ? '1px solid var(--fg)' : '1px solid var(--line-strong)',
                background: '#fff',
                padding: 40,
                borderRadius: 4,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {c.featured && (
                <div
                  style={{
                    position: 'absolute',
                    top: -1,
                    right: -1,
                    background: 'var(--accent)',
                    color: '#fff',
                    fontSize: 11,
                    fontFamily: 'var(--mono)',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    padding: '6px 10px',
                  }}
                >
                  Start here
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'baseline',
                }}
              >
                <div style={{ fontSize: 20, fontWeight: 500, letterSpacing: '-0.015em' }}>
                  {c.tier}
                </div>
                <Eyebrow>{c.tag}</Eyebrow>
              </div>
              <div
                style={{
                  marginTop: 24,
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: 10,
                }}
              >
                <span
                  style={{
                    fontSize: 56,
                    fontFamily: 'var(--serif)',
                    fontWeight: 400,
                    letterSpacing: '-0.02em',
                    lineHeight: 1,
                  }}
                >
                  {c.price}
                </span>
                <span style={{ fontSize: 14, color: 'var(--muted)' }}>{c.priceNote}</span>
              </div>
              <p
                style={{
                  marginTop: 12,
                  fontSize: 15,
                  color: 'var(--muted)',
                  lineHeight: 1.55,
                  maxWidth: 420,
                }}
              >
                {c.desc}
              </p>

              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: '32px 0 0',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 12,
                }}
              >
                {c.features.map((f) => (
                  <li
                    key={f}
                    style={{
                      display: 'flex',
                      gap: 12,
                      fontSize: 14.5,
                      lineHeight: 1.5,
                    }}
                  >
                    <span
                      style={{
                        color: 'var(--accent)',
                        fontFamily: 'var(--mono)',
                        fontSize: 12,
                        marginTop: 3,
                      }}
                    >
                      →
                    </span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <div style={{ marginTop: 'auto', paddingTop: 40 }}>
                <Button
                  variant={c.featured ? 'accent' : 'primary'}
                  size="lg"
                  style={{ width: '100%', justifyContent: 'center' }}
                  onClick={() => startCheckout(c.plan)}
                >
                  {c.cta} <span style={{ opacity: 0.5 }}>→</span>
                </Button>
                <div
                  style={{
                    marginTop: 12,
                    fontSize: 12,
                    color: 'var(--muted)',
                    fontFamily: 'var(--mono)',
                    textAlign: 'center',
                    letterSpacing: '0.04em',
                  }}
                >
                  STRIPE CHECKOUT · NO SALES CALL
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
